import React from "react";
import { Apple, Play } from "lucide-react";
import { APP_LINKS } from "../../data/mock";

// Both stores are live (Android approved 2026-08-03), so this stays true and
// the Google button is a real download link. The "Coming soon" branch below is
// kept only as a safety net if Android ever needs pulling.
const PLAY_STORE_AVAILABLE = true;

const AppStoreButtons = ({ variant = "default" }) => {
  const isSmall = variant === "small";

  return (
    <div className={`app-store-buttons ${variant}`}>
      {/* Apple — live */}
      <a
        href={APP_LINKS.appStore}
        className={`store-btn app-store ${isSmall ? "btn-small" : ""}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Apple size={isSmall ? 18 : 24} />
        <div className="store-btn-text">
          <span className="store-btn-label">Download on the</span>
          <span className="store-btn-name">App Store</span>
        </div>
      </a>

      {/* Google — coming soon (renders as a real link once available) */}
      {PLAY_STORE_AVAILABLE ? (
        <a
          href={APP_LINKS.playStore}
          className={`store-btn play-store ${isSmall ? "btn-small" : ""}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Play size={isSmall ? 18 : 24} fill="currentColor" />
          <div className="store-btn-text">
            <span className="store-btn-label">Get it on</span>
            <span className="store-btn-name">Google Play</span>
          </div>
        </a>
      ) : (
        <div
          className={`store-btn play-store coming-soon ${isSmall ? "btn-small" : ""}`}
          aria-disabled="true"
        >
          <Play size={isSmall ? 18 : 24} fill="currentColor" />
          <div className="store-btn-text">
            <span className="store-btn-label">Coming soon to</span>
            <span className="store-btn-name">Google Play</span>
          </div>
          <span className="store-btn-badge">Soon</span>
        </div>
      )}
    </div>
  );
};

export default AppStoreButtons;
